import { getDemoData, matchRestRequest } from '../utils'
import { WorkShift } from 'typings/common_defs'
import { differenceInHours } from 'date-fns'

function getNormalizedShiftIds(variables: Record<string, unknown>) {
  if (variables.id) {
    return [variables.id as number]
  }
  if (variables.ids) {
    return variables.ids as number[]
  }
  if (variables.shiftId) {
    return [variables.shiftId as number]
  }
  throw new Error('No shift ids provided')
}

export const mockGetShiftDetails = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shift_detail_17608ea0',
      'POST'
    ) ||
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shift_detail_8823cf26',
      'POST'
    ) ||
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shift_detail_64b380f9',
      'POST'
    ) ||
    matchRestRequest(
      request,
      '/company/graphql_dispatch/timeline_shift_8ec3f2cb',
      'POST'
    ),
  getResponse: async (request) => {
    const demoData = getDemoData()
    // temporary fix, we need to mock each query for shift details-like data separately
    const ids = getNormalizedShiftIds(request.data)

    return {
      data: {
        company: {
          shiftsDetail: ids.map((id) => {
            const shift = demoData.shifts.find(
              (shift) => shift.id === id
            ) as WorkShift
            return {
              ...shift,
              chargeRate: '24.7',
              totalEstimatedCharge: getEstimatedCharge(shift).toFixed(2),
              work: (shift.work ?? []).map((work) => {
                return {
                  ...work,
                  trips:
                    work.status === 'started'
                      ? [
                          {
                            status: 'active',
                            shareUrl: 'https://trck.at/zqY2mmOgp2',
                            eta: null,
                            etaSeconds: null,
                            locationStatus: 'traveling',
                            serviceDeviceId:
                              '258A3488-6238-4FBF-B9FE-AD6BB2AA7F09',
                          },
                        ]
                      : [],
                }
              }),
            }
          }),
        },
      },
    }
  },
}

function getEstimatedCharge(shift: WorkShift) {
  if (shift.payLumpSum) {
    return Number(shift.payLumpSum) * (shift.workersNeeded ?? 0) * 1.3
  }

  const hours = differenceInHours(
    new Date(shift.endsAt!),
    new Date(shift.startsAt!)
  )
  return Number(shift.payRate) * (shift.workersNeeded ?? 0) * hours * 1.3
}
